<template>
	<div class="serch">
		<!--顶部搜索框 -->
		<div class="nav">
			<van-icon name="arrow-left" size="1.2rem" color="#fff" @click="back" />
			<van-col span="20">
				<van-search class="special_serch" v-model="value" placeholder="您喜欢的" @blur.native.capture="shijiao" shape="round" background="#f1452f" />
			</van-col>
			<span @click="serch">搜索</span>
		</div>
		<!-- 搜索历史 -->
		<div class="history">
			<van-cell title="搜索历史">
				<!-- 使用 right-icon 插槽来自定义右侧图标 -->
				<van-icon size="1.2rem" slot="right-icon" name="delete" style="line-height: inherit;" @click="delt" />
			</van-cell>
			<div class="main">
				<div v-for="item in list" @click="serchMsg(item.name)">{{item.name}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		inject: ['reload'],
		data() {
			return {
				value: '',
				list: []
			}
		},
		created() {
			this.loadComments()
		},
		methods: {
			// 输入框失焦事件
			shijiao() {
				if (this.value == '') {
					//this.$toast('搜索内容不能为空!')
				} else {
					this.$router.push({
						path: '/serClass',
						query: {
							title: this.value
						}
					})
					var comment = {
						id: Date.now(),
						name: this.value
					}
					var list = JSON.parse(localStorage.getItem("cmts") || '[]');
					list.unshift(comment);
					localStorage.setItem('cmts', JSON.stringify(list));
					this.value = '';
				}
			}, 
			// 搜索点击事件
			serch() {
				if (this.value == '') {
					this.$toast('搜索内容不能为空!')
				} else {
					this.$router.push({
						path: '/serClass',
						query: {
							title: this.value
						}
					})
					var comment = {
						id: Date.now(),
						name: this.value
					}
					var list = JSON.parse(localStorage.getItem("cmts") || '[]');
					list.unshift(comment);
					localStorage.setItem('cmts', JSON.stringify(list));
					this.value = '';
				}
			},
			//从本地的localStorage中，加载评论列表
			loadComments() {
				var list = JSON.parse(localStorage.getItem("cmts") || '[]')
				this.list = list
			},
			//清除历史记录
			delt() {
				if (this.list.length == 0) {
					this.$toast('您没有可清除的记录哦~');
				} else {
					this.$dialog.confirm({
						message: '您确定要删除吗？'
					}).then(() => {
						localStorage.removeItem("cmts");
						this.$toast('清除成功');
						this.reload();
					})
				}
			},
			//点击历史记录
			serchMsg(name) {
				this.$router.push({
					path: '/serClass',
					query: {
						title: name
					}
				})
			}
		}
	}
</script>

<style scoped>
	@import "serch.css";
</style>



// WEBPACK FOOTER //
// src/components/serch/serch.vue